import { get, isEmpty } from 'lodash'
import { marked } from 'marked'

const toHtml = str => marked.parse(str)

export default (obj, key) => {
  const helpText = get(obj, `tooltips.${key}`)
  return isEmpty(helpText) ? null : toHtml(helpText)
}
